module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.a28928ed.eot";